import { FieldType } from "../../../enums/fieldType";
import { FieldDto } from "./fieldDto";

class DatePickerFieldDto extends FieldDto {

    public fieldType: FieldType = FieldType.DatePicker;
}

export { DatePickerFieldDto };